import { useEffect, useRef } from "react";
import { Link } from 'react-router-dom'
import $ from "jquery";
import jszip from "jszip";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import HomeCharts from '../components/HomeCharts';

pdfMake.vfs = pdfFonts.vfs;
const Home = () => {

    const chartConfig = {
        completedgames: {
            label: "Completed Games",
            data: [18, 22, 29, 25, 33, 40, 18, 25, 5, 35, 27, 20],
            color: "#adb5bd",
        },
        totalclubs: {
            label: "Total Clubs",
            data: [12, 18, 20, 25, 30, 38, 22, 29, 25, 33, 40, 18],
            color: "#adb5bd",
        },
        totalcoaches: {
            label: "Total Coaches",
            data: [12, 18, 20, 25, 30, 38, 22, 29, 25, 33, 40, 18],
            color: "#adb5bd",
        },
        activereferees: {
            label: "Total Teams",
            data: [60, 75, 90, 120, 150, 170, 115, 70, 145, 155, 110, 90],
            color: "#adb5bd",
        },
        pendingpayouts: {
            label: "Total Players",
            data: [5, 8, 6, 10, 7, 4, 6, 8, 2, 7, 3, 4],
            color: "#adb5bd",
        },
    };

    const table1 = useRef(null);
    const table2 = useRef(null);
    const table3 = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        let table11, table12, table13;

        if (table1.current) {
            table11 = $(table1.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }

        if (table2.current) {
            table12 = $(table2.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }
        if (table3.current) {
            table13 = $(table3.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }
        return () => {
            if (table11) table11.destroy();
            if (table12) table12.destroy();
            if (table13) table13.destroy();
        };
    }, []);

    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="dashTabs">
                        <div className="dash_cards_wrpr">
                            <ul className="nav nav-tabs d-flex align-items-center" id="myTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="completed_games" data-bs-toggle="tab" data-bs-target="#completedgames" type="button">
                                        <div className="card radius-10 bg-gradient-cosmic" style={{ background: '#12181a' }}>
                                            <div className="card-body">
                                                <div className="d-flex align-items-center card_box">
                                                    <div className="me-auto">
                                                        <p className="mb-0 text-white">Completed Games</p>
                                                        <h4 className="my-1 text-white">248</h4>
                                                    </div>
                                                    <div>
                                                        <i className="bx bx-baseball" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="total_revenue" data-bs-toggle="tab" data-bs-target="#totalrevenue" type="button">
                                        <div className="card radius-10 bg-gradient-cosmic" style={{ background: '#12181a' }}>
                                            <div className="card-body">
                                                <div className="d-flex align-items-center card_box">
                                                    <div className="me-auto">
                                                        <p className="mb-0 text-white">Total Clubs</p>
                                                        <h4 className="my-1 text-white">115</h4>
                                                    </div>
                                                    <div>
                                                        <i className="bx bx-building-house" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="invited_coaches" data-bs-toggle="tab" data-bs-target="#invitedcoaches" type="button">
                                        <div className="card radius-10 bg-gradient-cosmic" style={{ background: '#12181a' }}>
                                            <div className="card-body">
                                                <div className="d-flex align-items-center card_box">
                                                    <div className="me-auto">
                                                        <p className="mb-0 text-white">Total Coaches</p>
                                                        <h4 className="my-1 text-white">48</h4>
                                                    </div>
                                                    <div>
                                                        <i className="bx bx-group" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="active_referees" data-bs-toggle="tab" data-bs-target="#activereferees" type="button">
                                        <div className="card radius-10 bg-gradient-cosmic" style={{ background: '#12181a' }}>
                                            <div className="card-body">
                                                <div className="d-flex align-items-center card_box">
                                                    <div className="me-auto">
                                                        <p className="mb-0 text-white">Total Teams</p>
                                                        <h4 className="my-1 text-white">150</h4>
                                                    </div>
                                                    <div>
                                                        <i className="bx bx-group" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pending_payouts" data-bs-toggle="tab" data-bs-target="#pendingpayouts" type="button">
                                        <div className="card radius-10 bg-gradient-cosmic" style={{ background: '#12181a' }}>
                                            <div className="card-body">
                                                <div className="d-flex align-items-center card_box">
                                                    <div className="me-auto">
                                                        <p className="mb-0 text-white">Total players</p>
                                                        <h4 className="my-1 text-white">330</h4>
                                                    </div>
                                                    <div>
                                                        <i className="bx bx-group" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-lg-12">
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="completedgames" role="tabpanel">
                                    <div className="card radius-10 w-100">
                                        <div className="card-body">
                                            <p className="font-weight-bold mb-1 text-secondary">Completed Games</p>
                                            <div className="chart-container-0 mt-5">
                                                <HomeCharts
                                                    label={chartConfig.completedgames.label}
                                                    data={chartConfig.completedgames.data}
                                                    color={chartConfig.completedgames.color}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="totalrevenue" role="tabpanel">
                                    <div className="card radius-10 w-100">
                                        <div className="card-body">
                                            <p className="font-weight-bold mb-1 text-secondary">Total Clubs</p>
                                            <div className="chart-container-0 mt-5">
                                                <HomeCharts
                                                    label={chartConfig.totalclubs.label}
                                                    data={chartConfig.totalclubs.data}
                                                    color={chartConfig.totalclubs.color}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="invitedcoaches" role="tabpanel">
                                    <div className="card radius-10 w-100">
                                        <div className="card-body">
                                            <p className="font-weight-bold mb-1 text-secondary">Total Coaches</p>
                                            <div className="chart-container-0 mt-5">
                                                <HomeCharts
                                                    label={chartConfig.totalcoaches.label}
                                                    data={chartConfig.totalcoaches.data}
                                                    color={chartConfig.totalcoaches.color}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="activereferees" role="tabpanel">
                                    <div className="card radius-10 w-100">
                                        <div className="card-body">
                                            <p className="font-weight-bold mb-1 text-secondary">Total Teams</p>
                                            <div className="chart-container-0 mt-5">
                                                <HomeCharts
                                                    label={chartConfig.activereferees.label}
                                                    data={chartConfig.activereferees.data}
                                                    color={chartConfig.activereferees.color}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="pendingpayouts" role="tabpanel">
                                    <div className="card radius-10 w-100">
                                        <div className="card-body">
                                            <p className="font-weight-bold mb-1 text-secondary">Total Players</p>
                                            <div className="chart-container-0 mt-5">
                                                <HomeCharts
                                                    label={chartConfig.pendingpayouts.label}
                                                    data={chartConfig.pendingpayouts.data}
                                                    color={chartConfig.pendingpayouts.color}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card radius-10">
                                <div className="card-body">
                                    <h4 className="heading_rec">Recent Clubs</h4>
                                    <div className="table-responsive">
                                        <div className="entries-wrapper mb-3">
                                            <label className="entries-label">
                                                <span>Showing</span>
                                                <select className="entries-select">
                                                    <option value={10} selected>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </select>
                                                <span>Entries</span>
                                            </label>
                                        </div>
                                        <table ref={table1} className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Club Name</th>
                                                    <th>Club Director</th>
                                                    <th>Teams Count</th>
                                                    <th>Country</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Brooklyn Strikers</td>
                                                    <td>Robert Sean</td>
                                                    <td>20</td>
                                                    <td>USA</td>
                                                    <td>Pending</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/club-management-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#approve_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-check-circle" aria-label="Approve" data-bs-original-title="Approve" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#decline_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-x-circle" aria-label="Decline" data-bs-original-title="Decline" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Liberty United FC</td>
                                                    <td>John Clark</td>
                                                    <td>55</td>
                                                    <td>USA</td>
                                                    <td>Approved</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/club-management-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#approve_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-check-circle" aria-label="Approve" data-bs-original-title="Approve" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#decline_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-x-circle" aria-label="Decline" data-bs-original-title="Decline" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>London Royals</td>
                                                    <td>Richard Thomas</td>
                                                    <td>30</td>
                                                    <td>United Kingdom</td>
                                                    <td>Decline</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/club-management-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#approve_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-check-circle" aria-label="Approve" data-bs-original-title="Approve" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#decline_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-x-circle" aria-label="Decline" data-bs-original-title="Decline" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card radius-10">
                                <div className="card-body">
                                    <h4 className="heading_rec">Recent Games</h4>
                                    <div className="table-responsive">
                                        <div className="entries-wrapper mb-3">
                                            <label className="entries-label">
                                                <span>Showing</span>
                                                <select className="entries-select">
                                                    <option value={10} selected>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </select>
                                                <span>Entries</span>
                                            </label>
                                        </div>
                                        <table ref={table2} className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Game ID</th>
                                                    <th>Team</th>
                                                    <th>Venue</th>
                                                    <th>Date &amp; Time</th>
                                                    <th>Age Group</th>
                                                    <th>Referee</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>GM001</td>
                                                    <td>Team A</td>
                                                    <td>Stadium A</td>
                                                    <td>May-25-2025, 5:00 PM</td>
                                                    <td>U-15</td>
                                                    <td>Michael Anderson</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/game-management-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#edit_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="Reschedule" className="bx bx-calendar-edit" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#delete_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-trash" aria-label="Delete" data-bs-original-title="Delete" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>GM002</td>
                                                    <td>Team B</td>
                                                    <td>Stadium B</td>
                                                    <td>May-26-2025, 3:00 PM</td>
                                                    <td>U-14</td>
                                                    <td>David Thompson</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/game-management-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#edit_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="Reschedule" className="bx bx-calendar-edit" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#delete_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-trash" aria-label="Delete" data-bs-original-title="Delete" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>GM003</td>
                                                    <td>Team C</td>
                                                    <td>Stadium C</td>
                                                    <td>May-26-2025, 3:00 PM</td>
                                                    <td>U-16</td>
                                                    <td>James Parker</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/game-management-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#edit_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="Reschedule" className="bx bx-calendar-edit" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#delete_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-trash" aria-label="Delete" data-bs-original-title="Delete" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card radius-10">
                                <div className="card-body">
                                    <h4 className="heading_rec">Recent Teams</h4>
                                    <div className="table-responsive">
                                        <div className="entries-wrapper mb-3">
                                            <label className="entries-label">
                                                <span>Showing</span>
                                                <select className="entries-select">
                                                    <option value={10} selected>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </select>
                                                <span>Entries</span>
                                            </label>
                                        </div>
                                        <table ref={table3} className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Logo &amp; Name</th>
                                                    <th>Sporting complex</th>
                                                    <th>Age Group</th>
                                                    <th>Player Count</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <img src="images/team/t1.jpg" className="team_img" alt />
                                                        Team A
                                                    </td>
                                                    <td>Michael Anderson</td>
                                                    <td>U-17</td>
                                                    <td>23</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/team-management-detail">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#team_edit_modal" title="Edit">
                                                                    <i className="bx bx-edit" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#team_delete_modal" title="Delete">
                                                                    <i className="bx bx-trash" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <img src="images/team/t1.jpg" className="team_img" alt />
                                                        Team B
                                                    </td>
                                                    <td>David Thompson</td>
                                                    <td>U-18</td>
                                                    <td>30</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/team-management-detail">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#team_edit_modal" title="Edit">
                                                                    <i className="bx bx-edit" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#team_delete_modal" title="Delete">
                                                                    <i className="bx bx-trash" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <img src="images/team/t1.jpg" className="team_img" alt />
                                                        Team C
                                                    </td>
                                                    <td>James Parker</td>
                                                    <td>U-15</td>
                                                    <td>12</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/team-management-detail">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#team_edit_modal" title="Edit">
                                                                    <i className="bx bx-edit" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" data-bs-toggle="modal" data-bs-target="#team_delete_modal" title="Delete">
                                                                    <i className="bx bx-trash" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="approve_club_modal" tabIndex={-1} aria-labelledby="ApproveClubModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="ApproveClubModalLabel">Confirmation Alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <h5>Do you want to approve this club?</h5>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="decline_club_modal" tabIndex={-1} aria-labelledby="DeclineClubModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="DeclineClubModalLabel">Confirmation Alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <h5>Do you want to decline this club?</h5>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="edit_modal" tabIndex={-1} aria-labelledby="editNotiModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="editNotiModalLabel">Reschedule Game</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-3">
                                    <label className="form-label">Match ID</label>
                                    <input type="text" className="form-control" placeholder="Enter Match ID" />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Venue Location</label>
                                    <input type="text" className="form-control" placeholder="Enter Venue" />
                                </div>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Date</label>
                                        <input type="date" className="form-control" />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Local Time</label>
                                        <input type="time" className="form-control" />
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Teams Playing</label>
                                    <div className="row">
                                        <div className="col-md-6 mb-2">
                                            <input type="text" className="form-control" placeholder="Team 1 Name" />
                                            <input type="text" className="form-control mt-2" placeholder="Coach Name" />
                                        </div>
                                        <div className="col-md-6 mb-2">
                                            <input type="text" className="form-control" placeholder="Team 2 Name" />
                                            <input type="text" className="form-control mt-2" placeholder="Coach Name" />
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Level</label>
                                    <input type="text" className="form-control" placeholder="Mid" />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Fees</label>
                                    <input type="number" className="form-control" placeholder="Enter Fee Amount" />
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Save</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="delete_modal" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteModalLabel">Confirmation Alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <label htmlFor="blockMessage" className="form-label">Reason for Delete</label>
                            <textarea className="form-control mb-3" rows={3} placeholder="Enter any specific message..." defaultValue={""} />
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="team_edit_modal" tabIndex={-1} aria-labelledby="editTeamModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="editTeamModalLabel">Edit Team</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="row">
                                    <div className="col-md-12 mb-4">
                                        <label className="form-label d-block">Team Image</label>
                                        <input type="file" className="form-control" accept="image/*" />
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">Team Name</label>
                                        <input type="text" className="form-control" defaultValue="Team A" />
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">Sporting complex</label>
                                        <input type="text" className="form-control" defaultValue="Michael Anderson" />
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">Age Group</label>
                                        <select className="form-select" name="agegroup">
                                            <option value="U-11">U-11</option>
                                            <option value="U-12">U-12</option>
                                            <option value="U-13">U-13</option>
                                            <option value="U-14">U-14</option>
                                            <option value="U-15">U-15</option>
                                            <option value="U-16">U-16</option>
                                            <option value="U-17" selected>U-17</option>
                                        </select>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">Player Count</label>
                                        <input type="text" className="form-control" defaultValue={23} />
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">Country</label>
                                        <input type="text" className="form-control" defaultValue="USA" />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                            <button type="submit" className="btn btn-primary" data-bs-dismiss="modal">Save</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="team_delete_modal" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteModalLabel">Confirmation Alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <h5>Do you want to delete this team?</h5>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Home